import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {UserService, WebUserModel} from '../../system/user/user.service';
import {AuthGuard} from './auth.guard';
import {map} from 'rxjs/operators';
import {plainToInstance} from "class-transformer";
import {UserModel} from "common-shared";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class CurrentUserResolver  {

  constructor(private userService: UserService, private authGuard: AuthGuard, private authService: AuthService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserModel> | Promise<UserModel> | UserModel {
    if (this.authGuard.canActivate(route, state)) {
      return combineLatest([this.userService.getCurrent(), this.userService.getCurrentUserSpecs()]).pipe(map(([user, specs]) => {
        let currentUser = plainToInstance(WebUserModel, user.data);
        currentUser.Specs = specs;

        if(currentUser.TokenVersion != null){
          let auth = this.authService.getAuth();
          if(auth.User.TokenVersion == null){
            console.error('Login-Logout needed')
            this.authService.logout();
          }
          if([currentUser.TokenVersion, auth.User.TokenVersion].sort()[0] != currentUser.TokenVersion){
            console.error('Login-Logout needed');
            this.authService.logout();
          }
        }

        return currentUser;
      }));
    }
    return null;
  }
}
